<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'" (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>
<div class="page-contents">
    <div class="subBlockContainer" id='levelTwo'>
        <div class="subBlockContent" id="win-11-report-detail">
            <child-header title="Windows 11 Readiness Assessment" (closeEvent)="close()"></child-header>
            
            <app-windows-11-report-top></app-windows-11-report-top>

            <div *ngIf="!laodingCongratulation">
            <section class="new-devices-section">
                <div class="new-devices" style="            
                z-index: 9999;
                position: sticky;">
                    <p class="new-devices-styling">Upgrade 10 New Devices from:<br><span class="new-devices-styling-USD">$1,000 USD</span></p>
                </div>

                <div class="new-devices-section-content">
                    <h3>Set your business up for success<br>with Windows 11 Pro</h3>
                    <p>Based on your average spend of £400 per device, you can upgrade all your incompatible devices<br>for £4,000 and benefit from:</p>
                    <div class="your-options">Your Options</div>
                </div>

            </section>
            
            <section class="options">
                <div class="card-container">
                <!-- PREMIUM -->
                <div class="upgrade-card">  
                    <div class="plan">PREMIUM</div>
                    <img src="https://www.dickerdata.com.au/hubfs/windows-11/Premium.png" alt="AI PC" />
                    <h3>AI PC</h3>
                    <p><strong>Includes:</strong></p>
                    <ul class="cards-list">
                    <li><img src="https://www.dickerdata.com.au/hubfs/windows-11/Icon.png" class="icon-img"> Intelligent Performance</li>
                    <li><img src="https://www.dickerdata.com.au/hubfs/windows-11/Icon.png" class="icon-img"> Secure & Compliant</li>
                    <li><img src="https://www.dickerdata.com.au/hubfs/windows-11/Icon.png" class="icon-img"> Future-Proof</li>
                    <li><img src="https://www.dickerdata.com.au/hubfs/windows-11/Icon.png" class="icon-img"> Enhanced Creativity</li>
                    <li><img src="https://www.dickerdata.com.au/hubfs/windows-11/Icon.png" class="icon-img"> Inbuilt AI Capability</li>
                    </ul>
                    <a *ngIf="isAU" href="https://indd.adobe.com/embed/95cb12ee-81dd-4834-bb2f-092ee3444506?startpage=7" target="_blank">
                        <button class="upgrade-button">Upgrade Now</button>
                    </a>
                    <a *ngIf="!isAU" href="https://indd.adobe.com/embed/9c239b0c-1898-46db-ad22-ea2e55d73b19?startpage=6" target="_blank">
                        <button class="upgrade-button">Upgrade Now</button>
                    </a>
                </div>

                <!-- ADVANCED (Recommended) -->
                <div class="upgrade-card recommended">        
                    <div class="plan avandced">ADVANCED</div>
                    <img src="https://www.dickerdata.com.au/hubfs/windows-11/Advance.png"  class="avandced-overlay-img" alt="Copilot+ PC" />
                    <div class="tag">RECOMMENDED</div>
                    <h3 class="advance-h3">Copilot+ PC</h3>
                    <p><strong>Includes:</strong></p>
                    <ul class="cards-list">
                        <li><img src="https://www.dickerdata.com.au/hubfs/windows-11/tick-icon.png" class="icon-img"> Unmatched Performance</li>
                        <li><img src="https://www.dickerdata.com.au/hubfs/windows-11/tick-icon.png" class="icon-img"> Enhanced Security</li>
                        <li><img src="https://www.dickerdata.com.au/hubfs/windows-11/tick-icon.png" class="icon-img"> Future-Proof</li>
                        <li><img src="https://www.dickerdata.com.au/hubfs/windows-11/tick-icon.png" class="icon-img"> Inbuilt AI Capability</li>
                        <li><img src="https://www.dickerdata.com.au/hubfs/windows-11/tick-icon.png" class="icon-img"> All Day Battery Life</li>
                    </ul>
                    <a *ngIf="isAU" href="https://indd.adobe.com/embed/95cb12ee-81dd-4834-bb2f-092ee3444506?startpage=10" target="_blank">
                        <button class="upgrade-button active">Upgrade Now</button>
                    </a>
                    <a *ngIf="!isAU" href="https://indd.adobe.com/embed/9c239b0c-1898-46db-ad22-ea2e55d73b19?startpage=8" target="_blank">
                        <button class="upgrade-button active">Upgrade Now</button>
                    </a>
                </div>

                <!-- STANDARD -->
                <div class="upgrade-card">
                    <div class="plan">STANDARD</div>
                    <img src="https://www.dickerdata.com.au/hubfs/windows-11/Standard.png" alt="Windows 11 Pro" />
                    <h3 class="started-h3">Windows 11 Pro</h3>
                    <p><strong>Includes:</strong></p>
                    <ul class="cards-list">
                    <li><img src="https://www.dickerdata.com.au/hubfs/windows-11/Icon.png" class="icon-img"> Enhanced Productivity</li>
                    <li><img src="https://www.dickerdata.com.au/hubfs/windows-11/Icon.png" class="icon-img"> Secure & Compliant</li>
                    <li><img src="https://www.dickerdata.com.au/hubfs/windows-11/Icon.png" class="icon-img"> Remote Work Ready</li>
                    <li><img src="https://www.dickerdata.com.au/hubfs/windows-11/Icon.png" class="icon-img"> Energy Efficient</li>
                    <li><img src="https://www.dickerdata.com.au/hubfs/windows-11/x-cross.png" class="icon-img"> Inbuilt AI Capability</li>
                    </ul>
                    <a *ngIf="isAU" href="https://indd.adobe.com/embed/95cb12ee-81dd-4834-bb2f-092ee3444506?startpage=4" target="_blank">
                    <button class="upgrade-button">Upgrade Now</button>
                    </a>
                    <a *ngIf="!isAU" href="https://indd.adobe.com/embed/9c239b0c-1898-46db-ad22-ea2e55d73b19?startpage=4" target="_blank">
                    <button class="upgrade-button">Upgrade Now</button>
                    </a>
                </div>
                </div>
            </section>
            </div>

            <div *ngIf="laodingCongratulation">
                <section class="congratulation-section">
                    <div class="congratulation-container">
                        <div class="congratulation-content">
                            <p>Have you considered Copilot+ PCs and Copilot Licenses for your customers?</p>
                            <button class="congratulation-button">Learn More</button>
                        </div>
                        <div class="congratulation-content">
                            <img src="https://www.dickerdata.com.au/hubfs/windows-11/copilotPC.jpg" alt="Copilot+PC">
                        </div>
                    </div>
                </section>
            </div>

            <section class="why-win11">
            <h2>Why Windows 11</h2>
            <div class="stats-circle">
                <img src="https://www.dickerdata.com.au/hubfs/windows-11/why-win11.png">
            </div>
            </section>
            
            <section class="cost-nothing doing-nothing-section">
                <h2>The Cost Of Doing Nothing</h2>
                <p class="doing-nothing-subtitle">This could have real consequences for your business, including: </p>
                <div class="DN-image-container">
                    <img class="side-by-side-left" src="https://www.dickerdata.com.au/hubfs/windows-11/cost%20of%20nothing%20left.png" alt="">
                    <img class="side-by-side-right" src="https://www.dickerdata.com.au/hubfs/windows-11/Zero%20Access.png" alt="">
                </div>
                 <!-- [routerLink]="['/windows-11-readiness/windows-11-report/windows-11-report-extract']" -->
                <button  *ngIf="!laodingCongratulation" class="footer-export-btn" (click)="navigateToReportExtract()">Export Your Windows 11 Readiness Report</button>
            </section>
        </div>
        
    </div>
    <router-outlet></router-outlet>
</div>


